import GoogleIcon from "./GoogleIcon";
import { darkStyle } from "./GoogleIconStyles";

export default function GoogleButton({
  label = "Sign in with Google",
  onClick,
}: {
  label?: string;
  onClick: () => void;
}) {
  return (
    <div role="button" onClick={onClick} style={darkStyle}>
      <GoogleIcon />
      <span>{label}</span>
    </div>
  );
}
